"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldLocation = exports.ModelMutatorLocation = void 0;
exports.extractLocationRaw = extractLocationRaw;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var object_1 = require("../../../util/object");
var collection_field_1 = require("../collection.field");
var DEFAULT_LOCATION_DATA = {
    latitude: 0,
    longitude: 0,
    altitude: 0,
    accuracy: 0
};
var LocationRange = {
    latitude: { min: -90, max: 90 },
    longitude: { min: -180, max: 180 }
};
function extractLocationRaw(raw) {
    // To keep type safety around the raw location
    // data we need to assign only the keys we care about and are not null
    return {
        antennaHeight: raw.antennaHeight,
        fix: raw.fix,
        module: raw.module,
        capturedAt: raw.capturedAt,
        undulation: raw.undulation
    };
}
var ModelMutatorLocation = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorLocation, _super);
    function ModelMutatorLocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorLocation.prototype.manual = function (newValue) {
        if (!CollectionModelFieldLocation.isValidLocation(newValue)) {
            this.clear();
        }
        else {
            var value = { latitude: newValue.latitude, longitude: newValue.longitude, altitude: newValue.altitude };
            this.state.setFieldValue(this.field.id, { provider: 'manual', value: value });
        }
    };
    ModelMutatorLocation.prototype.edited = function (newValue) {
        if (!CollectionModelFieldLocation.isValidLocation(newValue)) {
            this.clear();
        }
        else {
            var value = { latitude: newValue.latitude, longitude: newValue.longitude, altitude: newValue.altitude };
            this.state.setFieldValue(this.field.id, { provider: 'edited', value: value });
        }
    };
    ModelMutatorLocation.prototype.gps = function (newValue, raw) {
        if (!CollectionModelFieldLocation.isValidLocation(newValue)) {
            this.clear();
            return;
        }
        var value = { latitude: newValue.latitude, longitude: newValue.longitude, altitude: newValue.altitude };
        if (newValue.accuracy != null) {
            value.accuracy = newValue.accuracy;
        }
        var stateValue = { provider: 'gps', value: value };
        if (raw != null) {
            object_1.IkeObject.assignNotNull(stateValue, extractLocationRaw(raw));
        }
        this.state.setFieldValue(this.field.id, stateValue);
    };
    ModelMutatorLocation.prototype.capture = function (captureId) {
        this.state.setFieldValue(this.field.id, { provider: 'truesize', captureId: captureId });
    };
    ModelMutatorLocation.prototype.clear = function () {
        this.state.setFieldValue(this.field.id, null);
    };
    return ModelMutatorLocation;
}(collection_field_1.ModelMutator));
exports.ModelMutatorLocation = ModelMutatorLocation;
var CollectionModelFieldLocation = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldLocation, _super);
    function CollectionModelFieldLocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldLocation.isLocationField = function (f) {
        return f.schema.type === CollectionModelFieldLocation.TYPE;
    };
    CollectionModelFieldLocation.isValidLocation = function (l) {
        if (l == null) {
            return false;
        }
        if (isNaN(l.latitude) || isNaN(l.longitude)) {
            return false;
        }
        if (l.latitude > LocationRange.latitude.max || l.latitude < LocationRange.latitude.min) {
            return false;
        }
        if (l.longitude > LocationRange.longitude.max || l.longitude < LocationRange.longitude.min) {
            return false;
        }
        return l.latitude !== DEFAULT_LOCATION_DATA.latitude ||
            l.longitude !== DEFAULT_LOCATION_DATA.longitude;
    };
    Object.defineProperty(CollectionModelFieldLocation.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorLocation(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldLocation.prototype, "value", {
        get: function () {
            if (this.stateValue == null) {
                return {
                    latitude: 0,
                    longitude: 0,
                    altitude: 0,
                    accuracy: 0
                };
            }
            if (this.isEdited()) {
                return this.stateValue.value;
            }
            if (this.isTrueSize()) {
                var _a = tslib_1.__read(this.getCaptures(), 1), capture = _a[0];
                if (capture == null) {
                    return null;
                }
                return capture.target;
            }
            if (this.isGPS()) {
                return this.stateValue.value;
            }
            if (this.isManual()) {
                return this.stateValue.value;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldLocation.prototype, "raw", {
        /**
         * Get the raw location data calculating alternative altitudes
         *
         * @remarks This cannot be null
         */
        get: function () {
            if (!this.isGPS()) {
                return {};
            }
            var stateValue = this.stateValue;
            var isAntennaHeightMissing = stateValue.antennaHeight == null || stateValue.antennaHeight === 0;
            if (isAntennaHeightMissing) {
                return tslib_1.__assign(tslib_1.__assign({}, extractLocationRaw(stateValue)), { deviceAltitude: stateValue.value.altitude, antennaHeight: undefined // Destroy antennaHeight if it is 0
                 });
            }
            return tslib_1.__assign(tslib_1.__assign({}, extractLocationRaw(stateValue)), { deviceAltitude: stateValue.antennaHeight + stateValue.value.altitude, groundAltitude: stateValue.value.altitude, antennaHeight: stateValue.antennaHeight });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldLocation.prototype, "provider", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.provider == null) {
                return 'manual';
            }
            return stateValue.provider;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldLocation.prototype.isManual = function () {
        return this.provider === CollectionModelFieldLocation.PROVIDER_MANUAL;
    };
    CollectionModelFieldLocation.prototype.isEdited = function () {
        return this.provider === CollectionModelFieldLocation.PROVIDER_EDITED;
    };
    CollectionModelFieldLocation.prototype.isTrueSize = function () {
        return this.provider === CollectionModelFieldLocation.PROVIDER_TRUE_SIZE;
    };
    CollectionModelFieldLocation.prototype.isGPS = function () {
        return this.provider === CollectionModelFieldLocation.PROVIDER_GPS;
    };
    CollectionModelFieldLocation.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldLocation.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldLocation.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldLocation.prototype.getCaptureIds = function () {
        if (this.isTrueSize()) {
            return [this.stateValue.captureId];
        }
        return [];
    };
    CollectionModelFieldLocation.prototype.hasValue = function () {
        return CollectionModelFieldLocation.isValidLocation(this.value);
    };
    CollectionModelFieldLocation.TYPE = core_api_1.IkeFieldType.LOCATION;
    CollectionModelFieldLocation.PROVIDER_MANUAL = 'manual';
    CollectionModelFieldLocation.PROVIDER_GPS = 'gps';
    CollectionModelFieldLocation.PROVIDER_TRUE_SIZE = 'truesize';
    CollectionModelFieldLocation.PROVIDER_EDITED = 'edited';
    return CollectionModelFieldLocation;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldLocation = CollectionModelFieldLocation;
//# sourceMappingURL=location.field.js.map